import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppLayout from "./App.layout";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import ScrollToTop from "./ScrollToTop ";
import RefreshHandle from "./RefreshHandle";

const browserHistory = createBrowserHistory();
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store()}>
      <Router history={browserHistory}>
        <ScrollToTop />
        {/* <RefreshHandle /> */}
        <AppLayout />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
